function acceptCookies(): void {
  const getCookie = (name: string): string | null => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  };

  if (!getCookie('okCookies')) {
    const footerCookies = document.querySelector('.footer__cookies') as HTMLElement;
    const footerCookiesCloseBtn = document.querySelector('.footer__cookies--close') as HTMLElement;

    if (footerCookies) {
      footerCookies.classList.add('js-active');
    }

    document.addEventListener('click', (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      if (target.classList.contains('js-accept-cookies')) {
        if (footerCookies) {
          footerCookies.classList.remove('js-active');
        }
        document.cookie = 'okCookies=true; path=/; max-age=' + 30 * 24 * 60 * 60;
      }
    });

    if (footerCookiesCloseBtn) {
      footerCookiesCloseBtn.addEventListener('click', () => {
        if (footerCookies) {
          footerCookies.classList.remove('js-active');
        }
      });
    }
  }
}

acceptCookies();
export default {};
